// extracted by mini-css-extract-plugin
export var wordContainer = "_l9-0";